import React, { useContext } from "react";
import PropTypes from "prop-types";

const CaptchaContext = React.createContext();

const useCaptcha = () => useContext(CaptchaContext);

const isLoaded = new Promise((done) => {
  const onloadtrigger = "_grecloaded";
  const grecaptchaScript = document.createElement("script");
  grecaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=${onloadtrigger}`;
  grecaptchaScript.setAttribute("async", "true")
  grecaptchaScript.setAttribute("defer", "true")
  window[onloadtrigger] = done;
  document.body.appendChild(grecaptchaScript);
});

const CaptchaProvider = ({ children }) => {
  const context = {
    siteKey: process.env.MIX_GRECAPTCHA_SITE_KEY,
    isLoaded: isLoaded,
  };

  return (
    <CaptchaContext.Provider value={context}>
      {children}
    </CaptchaContext.Provider>
  );
};

CaptchaProvider.propTypes = {
  children: PropTypes.node,
};

export { CaptchaProvider, useCaptcha };

/*
  <script src="https://www.google.com/recaptcha/api.js?render={{ env('RECAPTCHA_KEY') }}"></script>
  */
